import { Box, Typography, MediaFlex } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import { Link } from "react-router-dom"
import styled from "styled-components"

import { jewlr_t } from "helpers/application"
import { to_currency } from "helpers/number"

import { TitleWithLine } from "../jewlr/components"

import { TextColored } from "./components"
import { faqData } from "./data"
import FAQCarousel from "./faq-carousel"

const ReadMore = styled(Typography).attrs((props) => ({
  color: props.theme.extendWarranty.faqLink.color,
  fontSize: 16,
}))``

const Faq = ({ termsConditions }) => (
  <Box mb={3}>
    <TitleWithLine>FAQs</TitleWithLine>

    <MediaFlex
      flexDirection="row"
      flexWrap="wrap"
      greaterThanOrEqual="tablet"
      gutter={3}
      mb={3}
    >
      {faqData().map((item, index) => (
        <Box display="flex" flex="0 0 33%" key={`${item.title}-${index}`}>
          <Box alignItems="center" flex="1" textAlign="left">
            <Typography as="h1" fontSize={16} height="18%" mb={2} pr={5}>
              {item.title}
            </Typography>

            <Typography>{item.text}</Typography>
          </Box>
        </Box>
      ))}
    </MediaFlex>
    <FAQCarousel />
    {termsConditions && (
      <>
        <Box mb={6} textAlign="center">
          <ReadMore
            as={Link}
            data-lc="faq"
            style={{ textDecoration: "underline" }}
            to="/helpdesk/5e9f516d2c7d3a7e9aeb5bfe/5ea1f1682c7d3a7e9aeb8748"
          >
            Read more FAQs here
          </ReadMore>
        </Box>
        <Box
          fontSize={12}
          mx={{ _: 2, tablet: 0 }}
          textAlign={{ _: "center", tablet: "left" }}
        >
          <Link data-lc="faq" to="/info/terms-conditions">
            <TextColored mb={{ _: 2, tablet: 0 }}>
              Warranty and Protection Terms & Conditions.
            </TextColored>
            <Typography fontSize={12} id="plan-pricing">
              *Shown plan pricing is based on a {to_currency(149)} ring. Plan
              prices vary based on each item’s price,{" "}
              {jewlr_t("terms.personalization")} options, and length of
              coverage. Prices are listed on each product page and are displayed
              to the customer before checkout.
            </Typography>
          </Link>
        </Box>
      </>
    )}
  </Box>
)

Faq.propTypes = {
  termsConditions: PropTypes.bool,
}

export default Faq
